module.exports = __webpack_public_path__ + "static/falk-logo-footer-de8812a5c9f23c3de3d33265766e9010.png";